/**
 * Small notes kept in this browser across the trip to Google and back:
 * - which page you were on, so signing in brings you back there rather than to the start page;
 * - that sign-in was opened in a small window, so that window closes itself and leaves your page alone.
 * Both expire after 10 minutes.
 */
const RETURN = "ryoma.signin.return";
const POPUP = "ryoma.signin.popup";
const FRESH_MS = 10 * 60_000;

function read(key: string): { at: number; value: string } | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const v = JSON.parse(raw) as { at: number; value: string };
    return Date.now() - v.at < FRESH_MS ? v : null;
  } catch {
    return null;
  }
}
const write = (key: string, value: string) => { try { localStorage.setItem(key, JSON.stringify({ at: Date.now(), value })); } catch { /* storage blocked */ } };
const drop = (key: string) => { try { localStorage.removeItem(key); } catch { /* storage blocked */ } };

export function rememberReturn(hash: string): void {
  if (hash && hash !== "#/" && hash.startsWith("#/")) write(RETURN, hash);
  else drop(RETURN);
}
/** The page to go back to after signing in, once. */
export function takeReturn(): string | null {
  const v = read(RETURN);
  drop(RETURN);
  return v?.value ?? null;
}

export const markPopupSignIn = (): void => write(POPUP, "1");
/** True in the small sign-in window when it lands back on the platform with Google's answer. */
export function isPopupLanding(search: string): boolean {
  return new URLSearchParams(search).has("code") && read(POPUP) !== null;
}
export const clearPopupSignIn = (): void => drop(POPUP);
